import * as React from "react";
import {
  IconNameEnum,
  useHotelsStyles,
  useModuleBEM,
} from "@b2bportal/core-themes";
import { CoreHotelsComponent } from "@b2bportal/core-types";
import { useI18nContext } from "@hopper-b2b/i18n";
import { Icon } from "@tenant/ui";
import clsx from "clsx";
import defaultStyles from "./Arrow.module.scss";

export interface CarouselArrowProps {
  direction: "right" | "left";
  onClickEvent: () => void;
  className?: string;
}

export const CarouselArrow = ({
  direction,
  onClickEvent,
  className,
}: CarouselArrowProps) => {
  const COMPONENT_KEY = CoreHotelsComponent.ImageCarouselArrow;
  const styles = useHotelsStyles(COMPONENT_KEY, defaultStyles);
  const [, cn] = useModuleBEM(styles, COMPONENT_KEY);
  const { t } = useI18nContext();

  const nextText = t(
    "core-hotels.availabilityPage.results.hotelCard.carousel.next"
  );
  const previousText = t(
    "core-hotels.availabilityPage.results.hotelCard.carousel.previous"
  );
  const buttonAriaLabel = direction === "left" ? previousText : nextText;

  return (
    <button
      aria-label={buttonAriaLabel}
      className={clsx(
        cn("arrow", {
          right: direction === "right",
          left: direction === "left",
        }),
        className
      )}
      onClick={(event: React.MouseEvent) => {
        event.stopPropagation();
        event.preventDefault();
        onClickEvent();
      }}
    >
      <Icon
        className={cn("icon")}
        iconName={
          direction === "left"
            ? IconNameEnum.carouselLeftArrow
            : IconNameEnum.carouselRightArrow
        }
      />
    </button>
  );
};
